interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'FAQPage' | 'Article';
  data?: Record<string, unknown>;
  faqItems?: { question: string; answer: string }[];
}

export default function SchemaOrg({ type, data = {}, faqItems = [] }: SchemaOrgProps) {
  let schema: Record<string, unknown> = {};

  if (type === 'Organization') {
    schema = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'caoliushequ',
      url: 'https://caolnet.github.io',
      description: 'caoliushequ是深受用户喜爱的内容社区平台，提供丰富多元的内容交流与分享服务。',
      ...data,
    };
  } else if (type === 'WebSite') {
    schema = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'caoliushequ官方导航',
      url: 'https://caolnet.github.io',
      description: 'caoliushequ官方入口导航站，提供最新可用地址、访问教程及常见问题解答。',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://caolnet.github.io/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
      ...data,
    };
  } else if (type === 'WebPage') {
    schema = {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      ...data,
    };
  } else if (type === 'FAQPage') {
    schema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqItems.map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.answer,
        },
      })),
      ...data,
    };
  } else if (type === 'Article') {
    schema = {
      '@context': 'https://schema.org',
      '@type': 'Article',
      ...data,
    };
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}